// extracted by mini-css-extract-plugin
export var columnList = "_d2-0";